/* eslint-disable react/jsx-props-no-spreading */
import { useTheme } from '@mui/material';

export default function SoonImage(props: React.SVGAttributes<SVGSVGElement>) {
  const theme = useTheme();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
      width="1177.82"
      height="724.47"
      viewBox="0 0 1177.82 724.47"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <title>under construction</title>
      <path
        d="M1188.91,553.07a241.36,241.36,0,0,1-7.07,58.24q-2.38,9.63-5.53,18.86a222.72,222.72,0,0,1-8.92,22.32q-2.55,5.52-5.39,10.82a145.56,145.56,0,0,1-12.17,58.49,150.79,150.79,0,0,1-73.18,75.4,153.93,153.93,0,0,1-65.33,15H234.68a195.68,195.68,0,0,1-98.42-26.31l-.46-.26q-6.39-3.74-12.46-7.92a195.41,195.41,0,0,1-25.57-21.08A190.28,190.28,0,0,1,69.66,721.8a185.86,185.86,0,0,1-28.59-99.23c-18.95-33.25-30-73.08-30-115.88,0-54,17.56-103.26,46.41-140.55a197.6,197.6,0,0,1,19.71-21.93,183.42,183.42,0,0,1,22.54-18.45,175.38,175.38,0,0,1,20-12c2.89-1.47,5.79-2.86,8.74-4.15,2.59-1.15,5.21-2.22,7.86-3.23q4.77-1.81,9.66-3.33t9.65-2.66q7-1.71,14.24-2.78c4-.59,8-1,12-1.31,3.18-.24,6.39-.37,9.62-.41h1.75c3.56,0,7.1.14,10.61.38.37-.74.77-1.49,1.14-2.22,1.4-2.67,2.85-5.33,4.31-7.93a.25.25,0,0,1,0-.07c.25-.46.5-.91.76-1.35,1.18-2.13,2.41-4.24,3.67-6.33.58-1,1.15-1.94,1.74-2.88a7.66,7.66,0,0,1,.41-.68q.9-1.5,1.83-3,4.63-7.4,9.63-14.54l.85-1.22c.52-.74,1-1.46,1.58-2.2,1.38-1.93,2.8-3.87,4.23-5.77,1-1.36,2-2.71,3.08-4q3.9-5,8-10t8.52-9.87c.4-.45.8-.89,1.22-1.33l4.27-4.66h0c.21-.22.39-.42.59-.62h0c.51-.55,1-1.1,1.55-1.63,2.29-2.43,4.64-4.81,7-7.18a381.2,381.2,0,0,1,38.3-33.37c.53-.42,1.07-.82,1.6-1.22,2.54-1.91,5.12-3.8,7.7-5.66a405.31,405.31,0,0,1,44.41-27.7c1.06-.61,2.14-1.18,3.23-1.74a424,424,0,0,1,42.49-19.56c7.91-3.13,16-6.07,24.14-8.76,5.42-1.78,10.86-3.47,16.37-5.06Q459.4,102,472.5,99.05a463.35,463.35,0,0,1,78.24-10.66q12-.61,24.27-.63a465,465,0,0,1,117,14.8,4.22,4.22,0,0,0,3.63,1.89H699c1.46.4,2.91.8,4.37,1.22q12.23,3.52,24.11,7.69l2,.72a430.44,430.44,0,0,1,56.91,25,410.69,410.69,0,0,1,47.65,29.44q3.51,2.52,6.92,5.08,4.14-2.65,8.42-5.08a165.62,165.62,0,0,1,34.88-14.87,159.1,159.1,0,0,1,78.24-3.06c33.25,7.05,63.35,24.55,87.66,49.44a204.55,204.55,0,0,1,26.29,33.38c.55.86,1.1,1.73,1.63,2.61a220,220,0,0,1,16.74,33.37c.17.43.34.83.49,1.25a231.09,231.09,0,0,1,10.3,33.35c.12.58.26,1.15.38,1.73a240.11,240.11,0,0,1,4.92,33.37c0,.4,0,.81.08,1.23q.63,8.71.64,17.6c0,5.3-.18,10.56-.51,15.78,0,.57-.08,1.16-.13,1.75-.09,1.51-.22,3-.35,4.52a189.79,189.79,0,0,1,21.38,20.17q4.37,4.77,8.46,9.9a210.61,210.61,0,0,1,21.8,33.37C1179.19,475.33,1188.91,512.88,1188.91,553.07Z"
        transform="translate(-11.09 -87.76)"
        fill={theme.palette.secondary.main}
        opacity="0.1"
      />
      <path
        d="M1075.91,793.5c0,6.83-23.53,13.23-64.59,18.73H234.68a195.68,195.68,0,0,1-98.42-26.31l-.46-.26c11.8-4.3,33.1-8.31,62.09-11.93h0l1.3-.16c13-1.59,27.53-3.1,43.41-4.53.4,0,.81-.06,1.21-.11h0q18.9-1.68,40.21-3.15c.45,0,.89-.08,1.34-.1q8.22-.59,16.78-1.12h0l2.2-.14c41.55-2.58,88.78-4.64,140-6h.06q10.76-.3,21.75-.53,12.22-.29,24.74-.51c6.37-.14,12.82-.24,19.29-.34h.15c29.19-.44,59.35-.66,90.19-.66,76.26,0,148.34,1.39,212.21,3.89h.18c9.82.38,19.46.8,28.86,1.23l8,.38q15.91.76,31,1.63h0C999.07,770.24,1075.91,781.17,1075.91,793.5Z"
        transform="translate(-11.09 -87.76)"
        fill={theme.palette.secondary.main}
        opacity="0.1"
      />
      <g opacity="0.2">
        <path
          d="M691.37,751.79A19,19,0,0,1,691,755q-10.44-1.66-21-3c0-.28,0-.57,0-.86a16.88,16.88,0,0,1,2.5-8.48c2.06-3.26,5.19-5.3,8.64-5.19s6.44,2.34,8.29,5.71A16.87,16.87,0,0,1,691.37,751.79Z"
          transform="translate(-11.09 -87.76)"
          fill="#3f3d56"
        />
        <ellipse
          cx="681.21"
          cy="734.33"
          rx="14.01"
          ry="10.7"
          transform="translate(-85.32 1304.28) rotate(-88.19)"
          fill="#3f3d56"
        />
        <ellipse
          cx="681.75"
          cy="717.21"
          rx="14.01"
          ry="10.7"
          transform="translate(-67.68 1288.24) rotate(-88.19)"
          fill="#3f3d56"
        />
        <ellipse
          cx="682.29"
          cy="700.09"
          rx="14.01"
          ry="10.7"
          transform="translate(-50.05 1272.2) rotate(-88.19)"
          fill="#3f3d56"
        />
        <ellipse
          cx="682.83"
          cy="682.97"
          rx="14.01"
          ry="10.7"
          transform="translate(-32.42 1256.16) rotate(-88.19)"
          fill="#3f3d56"
        />
        <path
          d="M646.47,564.55a49.66,49.66,0,0,1-3.8-6l28.26-3.73-30.42-.73a51.38,51.38,0,0,1,.31-40.64l40.12,22.45-36.75-28.84a51.28,51.28,0,1,1,82.84,60,50.8,50.8,0,0,1,5.55,9.53l-37.09,17.8,39.33-11.83A51.34,51.34,0,0,1,725,630.47a51.28,51.28,0,1,1-80.56-2.54,51.28,51.28,0,0,1,2-63.38Z"
          transform="translate(-11.09 -87.76)"
          fill={theme.palette.secondary.main}
        />
        <path
          d="M737,599.13a51,51,0,0,1-12,31.34,51.28,51.28,0,1,1-80.56-2.54C637.87,619,737.18,593.38,737,599.13Z"
          transform="translate(-11.09 -87.76)"
          opacity="0.1"
        />
      </g>
      <g opacity="0.2">
        <path
          d="M539.37,751.79A19,19,0,0,1,539,755q-10.44-1.66-21-3c0-.28,0-.57,0-.86a16.88,16.88,0,0,1,2.5-8.48c2.06-3.26,5.19-5.3,8.64-5.19s6.44,2.34,8.29,5.71A16.87,16.87,0,0,1,539.37,751.79Z"
          transform="translate(-11.09 -87.76)"
          fill="#3f3d56"
        />
        <ellipse
          cx="529.21"
          cy="734.33"
          rx="14.01"
          ry="10.7"
          transform="translate(-232.53 1152.36) rotate(-88.19)"
          fill="#3f3d56"
        />
        <ellipse
          cx="529.75"
          cy="717.21"
          rx="14.01"
          ry="10.7"
          transform="translate(-214.89 1136.32) rotate(-88.19)"
          fill="#3f3d56"
        />
        <ellipse
          cx="530.29"
          cy="700.09"
          rx="14.01"
          ry="10.7"
          transform="translate(-197.26 1120.28) rotate(-88.19)"
          fill="#3f3d56"
        />
        <ellipse
          cx="530.83"
          cy="682.97"
          rx="14.01"
          ry="10.7"
          transform="translate(-179.63 1104.24) rotate(-88.19)"
          fill="#3f3d56"
        />
        <path
          d="M494.47,564.55a49.66,49.66,0,0,1-3.8-6l28.26-3.73-30.42-.73a51.38,51.38,0,0,1,.31-40.64l40.12,22.45-36.75-28.84a51.28,51.28,0,1,1,82.84,60,50.8,50.8,0,0,1,5.55,9.53l-37.09,17.8,39.33-11.83A51.34,51.34,0,0,1,573,630.47a51.28,51.28,0,1,1-80.56-2.54,51.28,51.28,0,0,1,2-63.38Z"
          transform="translate(-11.09 -87.76)"
          fill={theme.palette.secondary.main}
        />
        <path
          d="M585,599.13a51,51,0,0,1-12,31.34,51.28,51.28,0,1,1-80.56-2.54C485.87,619,585.18,593.38,585,599.13Z"
          transform="translate(-11.09 -87.76)"
          opacity="0.1"
        />
      </g>
      <g opacity="0.2">
        <path
          d="M954.57,762.73a37.3,37.3,0,0,1-.73,6.08q-20.1-3.21-40.49-5.74c0-.54,0-1.09,0-1.65a32.5,32.5,0,0,1,4.82-16.33c4-6.27,10-10.2,16.63-10s12.4,4.51,16,11A32.53,32.53,0,0,1,954.57,762.73Z"
          transform="translate(-11.09 -87.76)"
          fill="#3f3d56"
        />
        <ellipse
          cx="935"
          cy="729.11"
          rx="26.98"
          ry="20.61"
          transform="translate(165.69 1552.9) rotate(-88.19)"
          fill="#3f3d56"
        />
        <ellipse
          cx="936.04"
          cy="696.15"
          rx="26.98"
          ry="20.61"
          transform="translate(199.64 1522.02) rotate(-88.19)"
          fill="#3f3d56"
        />
        <ellipse
          cx="937.08"
          cy="663.2"
          rx="26.98"
          ry="20.61"
          transform="translate(233.59 1491.14) rotate(-88.19)"
          fill="#3f3d56"
        />
        <ellipse
          cx="938.12"
          cy="630.24"
          rx="26.98"
          ry="20.61"
          transform="matrix(0.03, -1, 1, 0.03, 267.53, 1460.26)"
          fill="#3f3d56"
        />
        <path
          d="M868.12,402.27a99.27,99.27,0,0,1-7.31-11.53l54.4-7.18-58.55-1.41a98.9,98.9,0,0,1,.58-78.24l77.25,43.21L863.75,291.6a98.72,98.72,0,1,1,159.47,115.56,98.71,98.71,0,0,1,10.69,18.35L962.5,459.8,1038.21,437a98.75,98.75,0,0,1-18.83,92.15,98.72,98.72,0,1,1-155.1-4.89,98.75,98.75,0,0,1,3.84-122Z"
          transform="translate(-11.09 -87.76)"
          fill={theme.palette.secondary.main}
        />
        <path
          d="M1042.42,468.83a98.34,98.34,0,0,1-23,60.34,98.72,98.72,0,1,1-155.1-4.89C851.58,507.07,1042.77,457.76,1042.42,468.83Z"
          transform="translate(-11.09 -87.76)"
          opacity="0.1"
        />
      </g>
      <polygon
        points="157.82 676.73 168.31 676.7 183.1 676.7 201.8 372.92 386.99 63.89 378.94 55.25 378.94 33.37 178.66 365.76 157.82 676.73"
        fill="#f1c0c0"
      />
      <polygon
        points="169.43 676.7 183.1 676.7 201.8 372.92 386.99 63.89 378.94 55.25 187.92 368.29 169.43 676.7"
        opacity="0.1"
      />
      <polygon
        points="126.91 679.26 606.76 715.98 607.17 716.01 1071.56 687.45 1071.91 687.43 1071.91 667.82 560.21 658.43 133.3 658.02 130.18 658.02 129.84 660.22 126.91 679.26"
        fill="#f1c0c0"
      />
      <polygon
        points="126.91 679.26 606.76 715.98 607.17 716.01 1071.56 687.45 1071.91 687.07 1071.91 668.23 1071.5 668.23 606.76 683.75 133.3 658.02 133.23 658.02 132.39 658.57 129.84 660.22 126.91 679.26"
        opacity="0.1"
      />
      <polygon
        points="126.91 679.26 606.76 715.98 606.76 683.75 132.39 658.57 129.84 660.22 126.91 679.26"
        opacity="0.1"
      />
      <polygon
        points="378.88 54.84 590.43 281.9 583.89 681.3 601.86 683.47 602.16 683.51 620.13 683.51 622.28 299.05 1018.41 431.37 1025.09 666.97 1039.55 668.59 1044.45 669.14 1033.11 415.03 619.01 269.65 391.95 33.6 378.88 33.6 378.88 54.84"
        fill="#f1c0c0"
      />
      <polygon
        points="620.65 291.7 622.28 299.05 1018.41 431.37 1025.09 666.97 1039.55 668.59 1028.21 426.47 620.65 291.7"
        opacity="0.1"
      />
      <polygon
        points="378.88 54.84 590.43 281.9 583.89 681.3 601.86 683.47 606.76 268.83 378.88 33.6 378.88 54.84"
        opacity="0.1"
      />
      <polygon
        points="621.42 451.99 766.71 480.6 766.76 480.61 1021.23 530.74 1032.88 526.07 1032.84 525.25 1032.08 509 621.57 426.05 621.42 451.99"
        fill="#f1c0c0"
      />
      <polygon
        points="766.76 480.61 1021.23 530.74 1032.88 526.07 1032.84 525.25 766.76 480.61"
        opacity="0.1"
      />
      <polygon
        points="776.49 350.56 780.42 566.9 782.45 677.89 800.34 677.29 811.6 676.91 808.1 353.69 800.34 351.11 798.64 350.56 776.49 350.56"
        fill="#f1c0c0"
      />
      <polygon
        points="776.65 350.51 776.65 350.56 780.42 566.9 782.45 677.89 800.34 677.29 800.34 350.51 776.65 350.51"
        opacity="0.1"
      />
      <path
        d="M507.35,493.57a22.79,22.79,0,0,1,3,1.95,19.85,19.85,0,0,1,3,3.29c4.29,5.55,8.25,12,7.83,19a7.73,7.73,0,0,1-2.23,5.5c-1.77,1.51-4.31,1.58-6.63,1.58-2.52,0-5.17,0-7.35-1.3s-4-3.83-6.58-3.77a3.37,3.37,0,0,1-1.1,0c-.89-.29-1.07-1.46-1.65-2.2-1-1.33-3.11-1-4.68-.42s-3.31,1.45-4.86.78a5.05,5.05,0,0,1-2.11-2.11c-3.71-6-4.5-13.21-5.2-20.18-.43-4.24-3.71-18.7,5.34-15.41,4,1.44,7.74,4.32,11.38,6.43Z"
        transform="translate(-11.09 -87.76)"
        fill="#3f3d56"
      />
      <path
        d="M498.41,495a4.46,4.46,0,0,0,5.49-.22,8.27,8.27,0,0,0,2.67-5.18c1-.31,1.51,1,2.15,1.8,1.12,1.36,3.4,1.34,4.42,2.79.71,1,.55,2.39,1.05,3.52.65,1.46,2.26,2.22,3.36,3.4a11.58,11.58,0,0,1,2.2,4.39l1.64,4.92a24.32,24.32,0,0,1,1.5,6.37,8.25,8.25,0,0,1-1.9,6.09c-2.2,2.37-5.81,2.62-9,2.55a11.58,11.58,0,0,1-3.16-.37c-2.83-.88-4.64-3.73-5.39-6.6s-.67-5.88-1.11-8.82a34.57,34.57,0,0,0-2.5-8.38c-.88-2.08-3.3-5.18-3.26-7.39C497.29,493.87,497.81,494.53,498.41,495Z"
        transform="translate(-11.09 -87.76)"
        fill="#3f3d56"
      />
      <path
        d="M502,484.87a16.51,16.51,0,0,1-.81-4.39c0-3,1.37-5.82,2.75-8.5l-11.43,1.55c-1.38.19-2.92.47-3.7,1.62a4,4,0,0,0,0,3.69,18.86,18.86,0,0,1,1.36,3.57,17.83,17.83,0,0,0,.37,3.21,6.8,6.8,0,0,0,1.47,2.07c3.27,3.62,5.72,7.89,8.16,12.12-.07-.12,6.89-5.51,6.61-7.27-.16-1-2.17-2.2-2.81-3.16A16.09,16.09,0,0,1,502,484.87Z"
        transform="translate(-11.09 -87.76)"
        fill="#be6f72"
      />
      <polygon
        points="588.91 358.04 588.91 367.89 420.24 400.79 411.49 406.09 381.3 406.09 381.3 400.54 547.02 360.5 588.91 358.04"
        fill="#f1c0c0"
      />
      <polygon
        points="588.91 367.89 420.24 400.79 411.49 406.09 381.3 406.09 548.25 370.36 588.91 367.89"
        opacity="0.1"
      />
      <path
        d="M464.58,725.42a13.07,13.07,0,0,0-15.9-3.38,4.19,4.19,0,0,0-1.46,1.14c-1,1.4-.36,3.33-.27,5.06.23,4.22-3.13,7.65-6.15,10.6-1.62,1.58-3.27,3.27-4,5.42s-.19,4.88,1.77,6a7.37,7.37,0,0,0,2.74.76,29.57,29.57,0,0,0,9.7.27c3.19-.61,6.32-2.42,7.7-5.36A5.65,5.65,0,0,1,460,743.8c1.76-1.39,4.46.24,6.46-.75,1.65-.82,1.72-2.11,1.74-3.81C468.26,734.54,467.56,729.22,464.58,725.42Z"
        transform="translate(-11.09 -87.76)"
        fill={theme.palette.secondary.main}
      />
      <path
        d="M488.58,725.24c1.23,3.24,1.4,6.77,1.56,10.23.09,2,.15,4.14-.93,5.83s-3.19,2.58-5.21,3c-4.17.86-9,.05-11.69-3.26-2.06-2.53-2.49-6-2.11-9.28.32-2.69,1-5.84-.93-7.75-.5-.51-1.15-.87-1.61-1.42-1-1.22-.84-3.06-.3-4.56a19.81,19.81,0,0,0,1.57-4.51c.08-.74,13.54.52,14.78,1.13,1.69.83,1.43,2.22,1.94,3.9C486.36,720.89,487.72,723,488.58,725.24Z"
        transform="translate(-11.09 -87.76)"
        fill={theme.palette.secondary.main}
      />
      <path
        d="M491.05,581.58c2.64,1.71,3.66,5.07,4.07,8.19,1.13,8.55-.85,17.19-1,25.82-.14,12.09,3.36,24.4.37,36.11-1.79,7-.27,15-1.95,22.07-.5,2.1-1.42,4.08-1.9,6.18-1,4.55.05,9.31,1.46,13.76a14.21,14.21,0,0,1,.85,3.73,13.42,13.42,0,0,1-1.46,5.64l-6,14.19c-.67,1.59-3.31,1.85-5,2.06-3.18.38-6.73.65-9.26-1.32s-3.14-5.27-3.53-8.35a128,128,0,0,1-1-17.83,14.69,14.69,0,0,0-.41-4.63c-.55-1.71-1.76-3.19-2.09-5-.42-2.34.77-4.64,1.21-7a21.09,21.09,0,0,0-.1-6.49c-.39-3.2-.84-6.4-1.35-9.58-.72-4.45.31-8.84,1-13.3.65-4.19-.18-8.46-1-12.62a34.79,34.79,0,0,1-1.25,10c-.53,1.59-1.29,3.11-1.75,4.73-2.05,7.27,2.32,14.9,1.7,22.43-.29,3.52-1.67,7-1.28,10.47.27,2.54,1.45,4.87,2.26,7.29s1.23,5.19,0,7.45c-3.25,6.14-.82,14.49,2.09,20.79a28.06,28.06,0,0,1,1.54,3.46c.86,2.84.14,5.89.37,8.85a5.58,5.58,0,0,1-4.69-1.41c-.44-.46-.8-1-1.23-1.48a12.21,12.21,0,0,0-4.18-2.61,5.49,5.49,0,0,0-3-.69,6,6,0,0,0-2.85,1.77,27.94,27.94,0,0,1-3.14,2.39,3.72,3.72,0,0,1-1.6.71,1.41,1.41,0,0,1-1.47-.75,1.78,1.78,0,0,1-.11-.52,79.14,79.14,0,0,1-.59-9.1c0-5.23-6.26-8.83-7.05-14-.63-4.17.54-8.42.15-12.62-.19-2.16-.79-4.28-.75-6.44,0-1.4.32-2.77.43-4.16a31.12,31.12,0,0,0-.07-4.63l-.31-4.83c-.3-4.77-.63-9.64-2.51-14a47.57,47.57,0,0,1-3.9-16.08c-.2-3.5-.07-7-.47-10.51-.36-3.17-1.16-6.32-.93-9.5.19-2.46,1-4.84,1.19-7.3.39-4.73-1.41-9.33-2.82-13.86s-2.45-9.55-.6-13.92a4.57,4.57,0,0,1,1.28-1.86,5.58,5.58,0,0,1,2.36-.88A183.11,183.11,0,0,1,483,579.07,17.34,17.34,0,0,1,491.05,581.58Z"
        transform="translate(-11.09 -87.76)"
        fill="#3f3d56"
      />
      <circle cx="423.19" cy="371.59" r="16.02" fill="#be6f72" />
      <path
        d="M431.18,479.36a5.72,5.72,0,0,1,0,2.79,6.32,6.32,0,0,1-1.05,1.76,45.2,45.2,0,0,1-5.13,5.58,9.29,9.29,0,0,0,4.79,4.73,27.81,27.81,0,0,0,6.61,1.89,9.32,9.32,0,0,0,3.48.24,9.23,9.23,0,0,0,3-1.36l8.9-5.33a17.78,17.78,0,0,0,3.7-2.67,9.11,9.11,0,0,0,2.58-6.26,1.72,1.72,0,0,0-.32-1.18,2.1,2.1,0,0,0-1.22-.51c-3.13-.69-5.6-3.23-7-6.11a32.36,32.36,0,0,1-2.43-9.27l-9.49,5c-1.41.75-2.81,1.5-4.27,2.15-.93.42-2.81.77-3.47,1.62C428.6,474,430.85,477.47,431.18,479.36Z"
        transform="translate(-11.09 -87.76)"
        fill="#be6f72"
      />
      <path
        d="M425.06,486.58a10.55,10.55,0,0,0-3.07,4.15c-.62,2,0,4.11.56,6.09a181.7,181.7,0,0,1,6,25.79c.84,6,1.15,12.09,1.56,18.16.84,12.38,2.06,32.12,3.69,44.42,6,.27,11.85-1.48,17.8-2.12,11.12-1.18,22.57,1.52,33.46-1-2.64-10.43-5.28-28.24-7.92-38.66a73.77,73.77,0,0,1-2.42-12.55c-.23-3.05-.09-6.11-.05-9.18.09-6-.24-12-.57-18-.38-7-.76-14-2.42-20.85a3.88,3.88,0,0,0-1.16-2.29c-1-.73-2.3-.47-3.49-.31a15.18,15.18,0,0,1-10.38-2.46c-1.32-.9-3.09-2-4.32-1a4.3,4.3,0,0,0-1,2.13,10.65,10.65,0,0,1-6.26,6.17,31.33,31.33,0,0,1-8.86,1.82,4.35,4.35,0,0,1-2.75-.31c-1.42-.87-1.52-4-3.31-4.21C428.58,482.19,426.12,485.57,425.06,486.58Z"
        transform="translate(-11.09 -87.76)"
        fill="#3f3d56"
      />
      <path
        d="M448.72,511c-3.69-3.53-5.31-8.65-8-13a28.94,28.94,0,0,0-6.91-7.6,20.61,20.61,0,0,1-3.76-3.19c-.95-1.17-1.67-2.73-3.11-3.18a3.76,3.76,0,0,0-3.37.93,33.16,33.16,0,0,0-2.5,2.66c-4.24,4.39-11.69,5-15.05,10.08a8.26,8.26,0,0,0-1.79,3.75,29.06,29.06,0,0,0,5.34,20.9,7.1,7.1,0,0,0,3.7,3,11.58,11.58,0,0,0,.72,5.5,147.07,147.07,0,0,0,6.81,18.55,44.87,44.87,0,0,0-1.34,7.19c-.7,6.11-.05,12.31-.71,18.43-.54,5-2,9.87-2.05,14.88,0,.8.07,1.75.76,2.16a2.3,2.3,0,0,0,1.19.25l12.3.37c7.14.21,14.35.42,21.38-.9a8.9,8.9,0,0,0,2.69-.85c2.38-1.33,3.17-4.33,3.55-7a61,61,0,0,0,.59-10.46c1.49,4.71,3.26,9.58,7.76,11.62,2.38,1.08,5.1,1,7.71.93a145.16,145.16,0,0,0,16.79-1.73,2.21,2.21,0,0,0,2.45-2.57l.06-5.46c.12-11.09-2.63-21.69-3.7-32.73-.34-3.48-.31-7-1.16-10.41-.35-1.43-.86-2.83-1.17-4.27a30.52,30.52,0,0,1-.5-4.27l-.78-11c-.37-5.09-.9-10-1.29-15.08a73,73,0,0,0-2.14-14.66c-.87-3-2.68-6.4-5.81-6.77-1.67-.19-3.29.54-4.88,1.05a19.72,19.72,0,0,1-12-.05,16.9,16.9,0,0,0-3.74-1,3.67,3.67,0,0,0-3.42,1.42,5.13,5.13,0,0,0-.53,2.52C452.34,491,451.47,501.29,448.72,511Z"
        transform="translate(-11.09 -87.76)"
        fill={theme.palette.secondary.main}
      />
      <path
        d="M432.63,511.3c-4.61-4.86-9.34-9.81-15.28-12.9-2.34-1.22-5-2.14-7.59-1.68s-5,2.71-4.88,5.34c.08,1.63,1.07,3.07,1.38,4.67.36,1.8-.16,3.72.4,5.46a9.24,9.24,0,0,0,2,3.07l7.08,8.39c3,3.5,6,7.05,9.86,9.47s8.86,3.55,13.1,1.83a16.1,16.1,0,0,0,7.18-6.59c1.76-2.8,3-5.86,4.65-8.75a43.45,43.45,0,0,1,10-12.13c-2.08-.54-4.69-1.3-6-3a9.91,9.91,0,0,1-.95-1.72l-1.62-3.5a4,4,0,0,0-3,1.13,25.16,25.16,0,0,1-2.23,2.27c-1.41,1.06-3.32,1.35-4.6,2.56a12.19,12.19,0,0,0-1.34,1.68A11.22,11.22,0,0,1,432.63,511.3Z"
        transform="translate(-11.09 -87.76)"
        fill={theme.palette.secondary.main}
      />
      <path
        d="M460.9,490.39c3.47-6.33,3.31-13.92,4.3-21.07a9.62,9.62,0,0,1,1.91-5.23c2-2.26,5.53-2.29,8.55-2,.89.1,2,.52,1.95,1.41a1.8,1.8,0,0,1-.45.85,23.79,23.79,0,0,0-4.94,13.12c1.57,1.09,4-1.15,5.51,0,1,.84.54,2.5-.06,3.7q-2.09,4.17-4.31,8.28a26.59,26.59,0,0,1-4.57,6.59c-1.27,1.22-2.76,2.18-4.05,3.38-3,2.81-4.81,6.78-7.91,9.52a1.62,1.62,0,0,1-1,.51,1.68,1.68,0,0,1-1.05-.47,15.16,15.16,0,0,1-3.78-4.57c-1.18-2.18-1-2.82.86-4.36C455.34,497.3,458.73,494.35,460.9,490.39Z"
        transform="translate(-11.09 -87.76)"
        fill="#be6f72"
      />
      <path
        d="M426.83,507c.6.37,1.34.79,2,.48a2.08,2.08,0,0,0,.67-.65,23.54,23.54,0,0,0,2.84-4.94,1.9,1.9,0,0,0,.21-.8c0-.64-.57-1.11-1.1-1.48a40.76,40.76,0,0,0-9.09-4.32c-2.64-1-5.4-1.87-8.2-1.62a7.82,7.82,0,0,0-5.47,2.78c-2,2.57,1.35,3.35,3.45,4.28C417,502.94,422.26,504.22,426.83,507Z"
        transform="translate(-11.09 -87.76)"
        fill={theme.palette.secondary.main}
      />
      <path
        d="M423.68,524a1.47,1.47,0,0,0,.42,1.26c.29-1.42-.09-2.92.21-4.35.44-2.15,2.53-3.77,2.71-5.93C423.19,514.23,423.71,521.68,423.68,524Z"
        transform="translate(-11.09 -87.76)"
        opacity="0.1"
      />
      <polygon
        points="588.91 358.04 588.91 367.89 548.25 370.36 547.02 360.5 588.91 358.04"
        opacity="0.2"
      />
      <path
        d="M419.86,461.73c2.54-2.07,1.07-6.41,2.79-9.19,1-1.52,2.69-2.32,4.35-3a19.79,19.79,0,0,1,6.35-1.76,7.37,7.37,0,0,1,6,2.21c.65.74,1.09,1.64,1.7,2.41a6.5,6.5,0,0,0,6.3,2.18c1.33-.3,2.71-1.31,2.62-2.67a3.77,3.77,0,0,0-1.2-2.14l-2.86-3.17c-3.25-3.6-6.86-7.42-11.63-8.32-3.32-.63-6.72.26-9.92,1.33-1.29.43-2.74,1.07-3.1,2.38-.24.9.12,1.88-.09,2.79-.41,1.81-2.73,2.42-3.81,3.94s-.75,3.32-1.06,5-1.21,3.32-1.32,5.06c-.07,1.05.46,3,1.64,3.38S419.13,460.48,419.86,461.73Z"
        transform="translate(-11.09 -87.76)"
        fill="#3f3d56"
      />
      <path
        d="M449,450.47a30,30,0,0,0-5.32-12.16,21.31,21.31,0,0,0-9.47-7.52,13.56,13.56,0,0,0-11.79.93,17.12,17.12,0,0,0-5.89,7.43c-2.59,5.58-3.55,12.4-.54,17.76,1.2-1.46,3.26-.8,5.08-1.33,2.28-.65,4.21-2.17,6.38-3.12C434,449.57,442,451.91,449,450.47Z"
        transform="translate(-11.09 -87.76)"
        fill="#fed253"
      />
      <path
        d="M417.52,450.16c-.23-1.8-.38-3.89.9-5.17a.65.65,0,0,1,.53-.24.69.69,0,0,1,.41.36,22.38,22.38,0,0,1,1.88,3.68,3.82,3.82,0,0,0-4,1.55"
        transform="translate(-11.09 -87.76)"
        opacity="0.1"
      />
      <path
        d="M440.89,445.08l-.36-3.57a1.63,1.63,0,0,1,.07-.88,1.13,1.13,0,0,1,1.46-.4,3,3,0,0,1,1.17,1.17,21,21,0,0,1,2.06,4.07,12.1,12.1,0,0,0-4.87.06"
        transform="translate(-11.09 -87.76)"
        opacity="0.1"
      />
      <polygon
        points="438.75 502.21 438.75 510.37 431.86 510.83 395.62 510.83 395.62 502.21 438.75 502.21"
        opacity="0.1"
      />
      <polygon
        points="438.75 502.21 438.75 510.83 395.62 510.83 281.04 367.3 281.04 360.52 305.06 360.52 438.75 502.21"
        fill="#f1c0c0"
      />
      <polygon
        points="438.75 502.21 438.75 510.83 395.62 510.83 281.04 367.3 281.04 360.52 305.06 360.52 438.75 502.21"
        opacity="0.1"
      />
      <polygon
        points="438.75 502.21 438.75 510.83 395.62 510.83 281.04 367.3 281.04 360.52 396.24 502.21 438.75 502.21"
        opacity="0.1"
      />
      <path
        d="M307.15,733.83a3,3,0,0,1-2.62,3.53c-2.78.94-5.73,1.87-7.7,4s-2.36,6.08,0,7.81a7.59,7.59,0,0,0,4,1.09c4.53.31,9.25.25,13.36-1.67,2.94-1.36,5.71-3.68,8.94-3.47,1.67.1,3.45.88,4.94.12s1.91-2.88,1.92-4.65a34.43,34.43,0,0,0-1.65-10.89c-.15-.48-6.51-.85-7.27-1l-7.71-1c-1.46-.19-4.61-1.29-5.76-.07S307.15,732.38,307.15,733.83Z"
        transform="translate(-11.09 -87.76)"
        fill={theme.palette.secondary.main}
      />
      <path
        d="M353.16,708.87a24.15,24.15,0,0,0,1.58,5.24c1.07,2.72,2.44,5.61,5.06,6.93,2.38,1.19,5.3.76,7.72-.37a6.36,6.36,0,0,0,2.57-1.95,7.74,7.74,0,0,0,1-4.49c0-3.87-.23-7.87-2-11.31-1.52-3-4.17-5.58-4.21-8.9l-9.11,1.76a2.6,2.6,0,0,0-1.34.53,2.31,2.31,0,0,0-.58,1.09A29.77,29.77,0,0,0,353.16,708.87Z"
        transform="translate(-11.09 -87.76)"
        fill={theme.palette.secondary.main}
      />
      <path
        d="M244.37,613.87c-.38,3.22-.22,6.67,1.46,9.45s5.22,4.62,8.28,3.51a1.21,1.21,0,0,0,.75-.57,1.41,1.41,0,0,0-.13-1,14.76,14.76,0,0,1,.31-11.12c.2-.46.63-1,1.1-.82a1,1,0,0,1,.45.46,5.23,5.23,0,0,1,.7,2.76,10.26,10.26,0,0,0-.08,2.65c.19.86,1.11,1.67,1.91,1.3a2,2,0,0,0,.91-1.29c2.23-6.45,1.22-13.5.2-20.25a1.06,1.06,0,0,0-1.19-1.11c-4.72-.47-7.3-1.6-10,2.79C246.72,604.33,244.37,609.42,244.37,613.87Z"
        transform="translate(-11.09 -87.76)"
        fill={theme.palette.secondary.main}
      />
      <path
        d="M299.55,597.46c-1.4,5.82-2.81,11.71-2.9,17.69a81.27,81.27,0,0,0,.84,11.13l1.05,8.66c.36,2.92.71,5.83,1.22,8.72a23.15,23.15,0,0,1,.53,4.53,24.26,24.26,0,0,1-.71,4.45,52,52,0,0,0-1.05,9.3c-.11,5,.51,10,.9,15a167.05,167.05,0,0,1-.35,29.92,11.22,11.22,0,0,0,1.64,7.71,9.92,9.92,0,0,1,1.45,2.38c.75,2.29-1,4.58-1.45,6.93a7,7,0,0,0,5.82,8c8,.95,16.22.52,23.43,4.18.76-2.22-.9-4.74-.14-7,.48-1.4,1.8-2.31,2.7-3.49a10.16,10.16,0,0,0,1.72-6.1,22.29,22.29,0,0,0-1.48-8.27c-.85-2.2-2.07-4.37-2-6.73,0-1.16.41-2.38-.06-3.45a5.39,5.39,0,0,0-1.29-1.61,20.33,20.33,0,0,1-5.23-11.85,54.58,54.58,0,0,1,.42-13.14c.49-4.14,1.15-8.51,3.78-11.74a75.33,75.33,0,0,1,2.11-29.25c.26-.88.67-1.9,1.57-2.11a2.24,2.24,0,0,1,1.92.76c1.57,1.47,2.32,3.6,3,5.64.75,2.21,1.51,4.57.94,6.83-.24,1-.72,1.88-1,2.84a8.42,8.42,0,0,0,.3,5.87,5.64,5.64,0,0,1,.72,2.21,6.12,6.12,0,0,1-.6,1.92,8.84,8.84,0,0,0,.83,7.15,25.89,25.89,0,0,0,4.67,5.73,21,21,0,0,0,.65,11.56,1.46,1.46,0,0,1,.13,1.11c-.18.38-.64.52-1,.79-1,.82-.38,2.37.29,3.44a78.88,78.88,0,0,0,6.07,8.42c2,2.39,1.82,7,4.8,7.86a9,9,0,0,0,3.8,0c2.94-.45,6.22-1.3,7.66-3.9.59-1.07.83-2.37,1.75-3.17s2.11-.94,2.62-1.9-.06-2.22.11-3.33,1.14-2,1.45-3.17c.74-2.7-2.41-4.92-2.84-7.68-.62-4,4.42-7,4.21-11-.44-8.69-.72-17.42-1.17-26.11a188.26,188.26,0,0,1-.24-23.39c.35-4.85,1-9.93-.78-14.44-2.56-6.36-9.62-9.93-16.45-10.61s-13.64.94-20.41,2A129,129,0,0,1,299.55,597.46Z"
        transform="translate(-11.09 -87.76)"
        fill="#3f3d56"
      />
      <circle cx="308.76" cy="398.1" r="16.02" fill="#fbbebe" />
      <path
        d="M313.33,504.87A6.83,6.83,0,0,1,306.8,509c-.58,2.4.81,4.82,2.4,6.71a28.48,28.48,0,0,0,27.26,9.35,13.45,13.45,0,0,0,5.37-2.24,11.91,11.91,0,0,0,4.1-7.1,35.3,35.3,0,0,0,.39-8.35,2.16,2.16,0,0,0-.44-1.54,2.2,2.2,0,0,0-1.4-.46c-3.38-.3-6.91-.43-9.88-2.09s-5.08-5.41-3.65-8.49c-.23.48-6.07.71-6.84.81-2.41.34-4.82.72-7.22,1.16a13.13,13.13,0,0,0-3.39.64c-1.45.75-.91.38-.57,1.74C313.44,501.22,314.19,502.71,313.33,504.87Z"
        transform="translate(-11.09 -87.76)"
        fill="#fbbebe"
      />
      <path
        d="M325.52,514.61a26.53,26.53,0,0,1-6.41-.71,9,9,0,0,1-5.26-3.51c-.74-1.12-1.22-2.53-2.4-3.16-1.93-1-4.13.69-5.67,2.24a20.6,20.6,0,0,1-4.82,3.88c-2.14,1.13-4.64,1.53-6.66,2.86a16.74,16.74,0,0,0-4,4.32l-14.17,19.3c-5.69,7.76-10.64,16.09-15.71,24.28-4.39,7.09-6.69,15.25-10,22.9a2.56,2.56,0,0,0-.31,1.54c.12.52.75.94,1.19.64-1.49,1.48-.18,4-.53,6.08a7.46,7.46,0,0,1-2.38,3.73,18.8,18.8,0,0,1,6.6.31,20.23,20.23,0,0,1,6.24,3c1.21-.19,1.1-2.34,2-3.14.54-.47,1.34-.41,2.05-.55,2.67-.52,3.73-3.73,5.78-5.54,1.71-1.51,4.13-2,5.94-3.42,2.94-2.31,3.57-6.42,5.11-9.83,1.31-2.89,3.37-5.41,4.52-8.37.75-1.92,1.11-4,2.18-5.77,1.71-2.86,4.93-4.38,8-5.75,1.94-.87,4-1.77,6.09-1.63-.11,4.65-.7,9.23.31,13.77.35,1.6.84,3.16,1.26,4.75,1.91,7.16,2.36,14.62,2.45,22a66.94,66.94,0,0,1,14-1.68c3.71-.11,7.41.37,11.12.3,4.4-.08,8.75-.93,13.15-1.23s9,0,12.89,2a122.46,122.46,0,0,1,.53-19l1.06-9.94A61.07,61.07,0,0,1,361,560.7c.58-2.28,1.42-4.48,2.06-6.75,2.25-8,1.84-16.54,1.41-24.87-.22-4.28-1.87-8.49-3.81-12.3a33.29,33.29,0,0,0-2.4-4.08A23.63,23.63,0,0,0,337.6,503a4.18,4.18,0,0,0-1.48.32,4.93,4.93,0,0,0-1.89,2.25A24.5,24.5,0,0,1,325.52,514.61Z"
        transform="translate(-11.09 -87.76)"
        fill="#3f3d56"
      />
      <path
        d="M305.76,491.17c.45-1,1.66-1.37,2.4-2.17,1.42-1.52.78-3.95,1-6,.36-3,2.85-5.51,5.7-6.58a18.42,18.42,0,0,1,9-.57,8.71,8.71,0,0,1,4.06,1.35c.52.38,1,.87,1.49,1.22a4,4,0,0,0,5.44-1.27c-3.54-4.26-7.46-8.76-12.84-10.07a26.34,26.34,0,0,0-5.61-.53c-2.49-.05-5.06-.09-7.36.86-3.13,1.29-5.33,4.26-6.46,7.46a36.27,36.27,0,0,0-1.57,10,37.67,37.67,0,0,0,0,6.8,18.8,18.8,0,0,0,3.34,8.57,2.59,2.59,0,0,0,1,.93C309.91,503.17,305.39,492,305.76,491.17Z"
        transform="translate(-11.09 -87.76)"
        fill="#3f3d56"
      />
      <path
        d="M334.33,474.68c-.55-4.71-3.91-8.6-7.48-11.73a27.58,27.58,0,0,0-10.05-6.05c-3.77-1.11-8.11-.87-11.34,1.38-2.6,1.81-4.25,4.69-5.52,7.59a23.89,23.89,0,0,0-2.41,11c.25,3.78,2.09,7.61,5.37,9.52,1.18-1.74,3.23-2.64,5.2-3.35A254.61,254.61,0,0,1,334.33,474.68Z"
        transform="translate(-11.09 -87.76)"
        fill="#fed253"
      />
      <path
        d="M304,472.72c.32,0,.53.33.69.6a25.35,25.35,0,0,1,2.09,4c-1.17.25-3.18.53-3.76-.5C302.71,476.3,303.08,472.67,304,472.72Z"
        transform="translate(-11.09 -87.76)"
        opacity="0.1"
      />
      <path
        d="M326.79,470.46c-.24.23-.52-.24-.52-.58V466a.57.57,0,0,1,.07-.31.47.47,0,0,1,.33-.16c.81-.09,1.48.6,2,1.26a21.12,21.12,0,0,1,2.05,3.41l-4.23-.13"
        transform="translate(-11.09 -87.76)"
        opacity="0.1"
      />
      <path
        d="M379.58,534.71a26.17,26.17,0,0,1,2.94-2.41c2.77-1.85,6.12-2.58,9.23-3.76s6.27-3.09,7.48-6.19a14.7,14.7,0,0,0,.58-6,6,6,0,0,0-.44-2.47,4.91,4.91,0,0,0-1.58-1.72c-4.22-3.12-9.88-3.37-15.12-3.05a94.77,94.77,0,0,0-33.41,8.34,2.9,2.9,0,0,0-1.4,1,2.86,2.86,0,0,0-.27,1.39,23,23,0,0,0,1.13,8.71c1.38,3.56,4.22,6.43,5.41,10.06.54,1.63.72,3.36,1.19,5a7,7,0,0,0,2.81,4.18c3.95,2.36,7.68-.81,10.42-3.27Z"
        transform="translate(-11.09 -87.76)"
        fill="#3f3d56"
      />
      <path
        d="M327.85,548.56l-5.07-11.06a38.71,38.71,0,0,1-1.92-4.73c-.58-1.93-.86-3.93-1.4-5.87-1.78-6.46-6.27-11.84-8.46-18.17a3.45,3.45,0,0,0-.82-1.53,2.67,2.67,0,0,0-2.23-.4c-3.06.53-5.45,2.86-8.25,4.18-1.3.6-2.7,1-4,1.69a5,5,0,0,0-2.68,3.19c-.31,1.53.45,3,1.09,4.49,2.72,6.14,3.34,13,3.46,19.72.09,4.52-.14,9.37-2.81,13-5.13,7-1.85,17.28.07,25.75.23,1,.5,2.08.66,3.14a28.87,28.87,0,0,1,.23,4c0,4.49-.25,9.12-2.13,13.19a14.76,14.76,0,0,0,6,1.7q8.71,1.11,17.49,1.56a19.06,19.06,0,0,0,5.49-.28,10,10,0,0,0,7.39-9.8c.32,2.77.91,5.78,2.92,7.7s4.94,2.21,7.67,2.36a142.6,142.6,0,0,0,23.1-.65,4,4,0,0,0,1.42-.33c1.48-.74,1.56-2.78,1.44-4.42-.22-3.07-.45-6.14-.82-9.19a37.61,37.61,0,0,1-.48-5.88,33.83,33.83,0,0,1,1-6c1.34-6.24,2.4-12.61,1.95-19a32.06,32.06,0,0,1-.19-4.69c.26-3.53,2.12-6.89,1.77-10.4-1-10.32-1.81-20.91-4.69-30.87-.52-1.78-1.18-3.69-2.73-4.71-2-1.34-4.81-.64-7.1-1.49a17.76,17.76,0,0,1-3.05-1.81,14,14,0,0,0-6.89-2.12c-1.84-.07-3.89.34-5,1.82a7.26,7.26,0,0,0-1,2.73c-1.45,6.1-3.15,12.13-4.85,18.16l-1.63,5.78-4.37,15.52C328,546.49,328.29,547,327.85,548.56Z"
        transform="translate(-11.09 -87.76)"
        fill={theme.palette.secondary.main}
      />
      <polyline
        points="342.33 400.25 439.06 501.9 439.06 510.52 395.93 510.52 323.24 415.65"
        fill={theme.palette.secondary.main}
      />
      <polyline
        points="342.33 400.25 439.06 501.9 439.06 510.52 395.93 510.52 323.24 415.65"
        opacity="0.1"
      />
      <polygon
        points="324.78 414.31 325.09 414.42 396.55 501.9 439.06 501.9 439.06 510.52 395.93 510.52 323.24 415.65 324.78 414.31"
        opacity="0.1"
      />
      <path
        d="M347,504.21c-3.5,1.53-7.39,3.49-8.44,7.17a4.12,4.12,0,0,0-.13,2,4.08,4.08,0,0,0,3.67,2.81,12,12,0,0,0,4.81-.88l20.65-6.82c.56-.18,1.2-.45,1.34-1a1.72,1.72,0,0,0-.2-1c-.64-1.56-1.27-4.75-2.61-5.84-1.1-.88-3.28-.57-4.61-.55C356.36,500.14,351.55,502.21,347,504.21Z"
        transform="translate(-11.09 -87.76)"
        fill={theme.palette.secondary.main}
      />
      <path
        d="M365.41,509.3a33.21,33.21,0,0,1,10.25,1.59,18.26,18.26,0,0,1,8.49,5.8,6.36,6.36,0,0,1,1.34,2.62c.2,1,3.46,1.6,2.74,2.28,2.19-.35,1.67.68,3.89.66s4.62-.59,5.95-2.36a7.73,7.73,0,0,0,1.17-4.89,8.33,8.33,0,0,0-.66-3.46c-1-2.1-3.3-3.23-5.42-4.2l-17.86-8.17A11.86,11.86,0,0,0,372,498a12.34,12.34,0,0,0-2.91.07L361,499a12.13,12.13,0,0,1,5.53,10.67"
        transform="translate(-11.09 -87.76)"
        fill="#3f3d56"
      />
    </svg>
  );
}
